module.exports = __webpack_public_path__ + "assets/media/no_results.9d64ae78.svg";